import { AskCareerScoutStarters } from './AskCareerScoutStarters';
import { Box, Heading } from '../../../../../mads';
import { useI18n } from '../../../../../shared/I18n';
import { ViewJobDivider } from '../Divider';

import { colors, spacing } from '@indeed/ifl-tokens/react-native';
import React from 'react';
import { StyleSheet } from 'react-native';

/**
 * Standalone "Ask Career Scout" section that appears above Match Overview.
 * Contains a heading and horizontally scrollable question starter chips.
 */
export const AskCareerScoutStartersSection: React.FC = () => {
    const gt = useI18n();

    return (
        <>
            <Box sx={styles.container}>
                <Heading level={3} sx={styles.heading}>
                    {gt.gettext('Ask Career Scout')}
                </Heading>
                <AskCareerScoutStarters />
            </Box>
            <ViewJobDivider />
        </>
    );
};

const styles = StyleSheet.create({
    container: {
        marginBlock: spacing.s6,
        gap: spacing.s3,
    },
    heading: {
        fontSize: 20,
        fontWeight: '700',
        lineHeight: 30,
        letterSpacing: 0,
        color: colors.foregroundStrong,
    },
});
